import type * as api from '@gitbook/api-client';

import { apiClient } from '../api';

/**
 * Create a new empty space as draft content of a site that already has content: a new section
 * if the site uses sections, a new variant otherwise. Authorized by the site permissions.
 */
export async function createDraftSiteSpace(input: {
    organizationId: string;
    site: api.Site;
    siteStructure: api.SiteStructure;
    title: string;
}): Promise<api.Space> {
    const { organizationId, site, siteStructure, title } = input;
    const body = { spaceId: null, title, draft: true, empty: true } as const;

    if (siteStructure.type === 'sections') {
        const { data: siteSection } = await apiClient.siteSections.addSectionToSite(
            organizationId,
            site.id,
            body
        );
        const space = siteSection.siteSpaces[0]?.space;
        if (!space) {
            throw new Error('The created section has no space');
        }
        return space;
    }

    const { data: siteSpace } = await apiClient.siteSpaces.addSpaceToSite(
        organizationId,
        site.id,
        body,
        { returnPreference: 'representation' }
    );
    return siteSpace.space;
}
